import { Component } from '@angular/core';

@Component({
  selector: 'app-loan-amount-modifier',
  templateUrl: './loan-amount-modifier.component.html',
  styleUrls: ['./loan-amount-modifier.component.scss']
})
export class LoanAmountModifierComponent {

}
